module.exports = __webpack_public_path__ + "img/sl_v.2277fd3c.jpg";